import { BaseRouteService } from 'core/services';

class ApplicationRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'fulfillment-organizations/';
	}

	find(filter) {
		return super.find(this.base + 'search', filter);
	}

	countWarehouses(filter) {
		return super.find(this.base + 'count-warehouses', filter);
	}

	getOrganizationInfo() {
		return super.find(this.base + 'organization-info');
	}

	get(id, options) {
		return super.get(this.base + '{id}/{?embed,fields}', id, options);
	}

	update(resource, sourceOfChange) {
		return super.update(this.base + '{id}/?sourceOfChange={sourceOfChange}', resource, { sourceOfChange });
	}

	delete(resource) {
		return super.delete(this.base + '{id}', resource);
	}

	changeStatus(id, isReactivate) {
		return super.update(this.base + 'change-status/{id}/?isReactivate={isReactivate}', null, { id, isReactivate });
	}

	create(sourceOfChange) {
		return super.create(this.base + '?sourceOfChange={sourceOfChange}', { sourceOfChange });
	}

	updateSellerWarehouseManagements(updateSellerWarehouseManagementsParams, sourceOfChange) {
		return super.update(
			this.base + 'update-warehouse-managements/?sourceOfChange={sourceOfChange}',
			updateSellerWarehouseManagementsParams,
			{ sourceOfChange }
		);
	}

	updateSellerWarehouses(updateSellerWarehousesParams, sourceOfChange) {
		return super.update(
			this.base + 'update-seller-warehouses/?sourceOfChange={sourceOfChange}',
			updateSellerWarehousesParams,
			{ sourceOfChange }
		);
	}
}

export default ApplicationRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/ApplicationRouteService.js